module.exports = __webpack_public_path__ + "static/media/menu_relatorios.f63f7047.png";